import React from "react";
import './Footer.scss';
import { FooterLogo } from "../FooterLogo";

export const Footer = () => {
  return (
    <footer className="Footer">
      <FooterLogo />
    </footer>
  );
};
